import React from 'react';
import styled, { StylesProps, cx, useStyles } from '../../../lib/styles';
import BlockWrapper from '../BlockWrapper';
import { CallToActionButton } from '../CallToActionButton';
import { ButtonPosition, DefaultBlockFields } from '../GroupBlock';

import contentBlockStyles from './ContentBlock_styles';
import Typography from '../../../components/presentational/Typography';
import { Brand } from '../../../lib/theme';
import Spacer from '../../../components/presentational/Spacer';
import globalStyles from '../../../lib/styles/Global_styles';
import BlockTitle from '../BlockTitle';
import _ from 'lodash';

export interface ContentBlockProps {
  type: 'acf_content_block';
  brand: string;
  classes: string;
  background_colour: string;
  desktop_spacing: string;
  mobile_spacing: string;
  block: ContentBlockFields;
}

export interface ContentBlockFields extends DefaultBlockFields {
  content: string;
}

const ContentBlock = ({
  type,
  classes,
  brand,
  background_colour,
  desktop_spacing,
  mobile_spacing,
  block: { title, subtitle, content, cta_button },
  styles,
}: ContentBlockProps & StylesProps<typeof contentBlockStyles>) => {
  // console.log('Content Block', {content});

  const globals = useStyles(globalStyles());

  return (
    <BlockWrapper
      {...{
        type,
        classes,
        brand,
        background_colour,
        desktop_spacing,
        mobile_spacing,
      }}
    >
      <Spacer
        space={['m', 'l']}
        className={cx(`content-container container`, styles.container, classes)}
      >
        {(cta_button.label || cta_button.icon) &&
          (cta_button.button_position == ButtonPosition.Above ||
            cta_button.button_position == ButtonPosition.AboveAndBelow) && (
            <CallToActionButton
              {..._.merge(cta_button, { cta_classes: 'mb-2' })}
            />
          )}

        <BlockTitle {...{ title, subtitle, brand }} />

        <Typography
          brand={brand as Brand}
          className={globals.blockContentWrapper}
          dangerouslySetInnerHTML={{ __html: content }}
          family={'primary'}
        />

        {(cta_button.label || cta_button.icon) &&
          (cta_button.button_position == ButtonPosition.Below ||
            cta_button.button_position == ButtonPosition.AboveAndBelow) && (
            <CallToActionButton
              {..._.merge(cta_button, { cta_classes: 'mt-4 mb-2' })}
            />
          )}
      </Spacer>
    </BlockWrapper>
  );
};

export default styled(contentBlockStyles)(ContentBlock);
